import './live-indicator.scss'

// Minimal presentational "Live" pill. Pulses green while healthy; drops to a
// muted, non-pulsing "Reconnecting…" when the last poll/refresh failed so it
// never claims freshness it doesn't have.
export const LiveIndicator = ({ health, lastUpdatedAt }) => {
  const reconnecting = health === 'reconnecting'
  const title = lastUpdatedAt ? `Last updated ${lastUpdatedAt.toLocaleTimeString()}` : 'Live'
  return (
    <span
      data-testid="live-indicator"
      title={reconnecting ? 'Reconnecting…' : title}
      className={`live-indicator ${reconnecting ? 'is-reconnecting' : 'is-live'}`}
    >
      <span className="live-indicator__dot" />
      {reconnecting ? 'Reconnecting…' : 'Live'}
    </span>
  )
}
